import * as React from 'react';
import { ISpecialAuthorizationsGroup, ISpecialAuthorization } from './Types';
import { Table, Button, ButtonToolbar } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import SpecialAuthorizationsListRow from './SpecialAuthorizationsListRow';

interface ISpecialAuthorizationsListGroupProps {
    group: ISpecialAuthorizationsGroup;
    key: number;
    toggleExpansion: (value: number) => void;
    toggleItemIsAssigned: (item: ISpecialAuthorization) => void;
}

const SpecialAuthorizationsListGroup = (props: ISpecialAuthorizationsListGroupProps) => {
    return (
        <Table className="rights-table" hover responsive>
            <thead>
                <tr>
                    <th className="text">
                        <Button
                            bsStyle="primary"
                            bsSize="xsmall"
                            onClick={() => props.toggleExpansion(props.group.value)}
                        >
                            <i className="material-icons">
                                {props.group.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down'}
                            </i>
                        </Button>
                        <span> {Translate(props.group.translationKey)}</span>
                    </th>
                    <th>
                        {props.group.items.filter((x: ISpecialAuthorization) => x.isAssigned)
                            .length +
                            ' / ' +
                            props.group.items.length}
                    </th>
                </tr>
            </thead>
            <tbody>
                {props.group.isExpanded &&
                    props.group.items
                        .sort(
                            (a: ISpecialAuthorization, b: ISpecialAuthorization) =>
                                a.value - b.value
                        )
                        .map((x: ISpecialAuthorization) => {
                            return (
                                <SpecialAuthorizationsListRow
                                    item={x}
                                    key={x.value}
                                    isAssignedChange={props.toggleItemIsAssigned}
                                />
                            );
                        })}
            </tbody>
        </Table>
    );
};

export default SpecialAuthorizationsListGroup;
